define([
  "jquery",
  "core/ajax",
  "core/str",
  "core/notification",
  "sweetalert2",
  "datatables.net",
  "datatables.net-bs4",
  "datatables.net-buttons",
  "datatables.net-buttons-bs4",
  "datatables.net-buttons-colvis",
  "datatables.net-buttons-print",
  "datatables.net-buttons-html",
  "datatables.net-buttons-flash",
  "datatables.net-responsive",
  "datatables.net-responsive-bs4",
  "datatables.net-fixedcolumn-bs4",
  "jszip",
], function($, ajax, str, notification, Swal){
  var index = {
    dom: {
      main: null,
    },
    langs: {
      yes: null,
      no: null,
      withdraw: null,
      approved: null,
      applied: null,
      reject: null,
      rejected: null,
      approve: null,
      notApplicable: null,
      apply: null,
    },
    action: {
      getString: function(){
        str.get_strings([
            { key: "yes", component: "local_buykart" },
            { key: "no", component: "local_buykart" },
            { key: "withdraw", component: "local_buykart" },
            { key: "approved", component: "local_buykart" },
            { key: "applied", component: "local_buykart" },
            { key: "reject", component: "local_buykart" },
            { key: "rejected", component: "local_buykart" },
            { key: "approve", component: "local_buykart" },
            { key: "notapplicable", component: "local_buykart" },
            { key: "apply", component: "local_buykart" },
          ])
          .done(function(s){
            index.langs.yes = s[0];
            index.langs.no = s[1];
            index.langs.withdraw = s[2];
            index.langs.approved = s[3];
            index.langs.applied = s[4];
            index.langs.reject = s[5];
            index.langs.rejected = s[6];
            index.langs.approve = s[7];
            index.langs.notApplicable = s[8];
            index.langs.apply = s[9];
            index.init();
          })
          .fail(function(){});
      },
      initDomVariable: function(json){
        index.dom.chApply = index.dom.main.find(
          "#cid-" + json.courseid + "-uid-" + json.userid + "-chstatus-apply"
        );
        index.dom.chRejected = index.dom.main.find(
          "#cid-" + json.courseid + "-uid-" + json.userid + "-crstatus-rejected"
        );
        index.dom.notApplicable = index.dom.main.find(
          "#cid-" +
            json.courseid +
            "-uid-" +
            json.userid +
            "-crstatus-notapplicable"
        );
        index.dom.chApprove = index.dom.main.find(
          "#cid-" + json.courseid + "-uid-" + json.userid + "-chstatus-approve"
        );
        index.dom.chApplied = index.dom.main.find(
          "#cid-" + json.courseid + "-uid-" + json.userid + "-crstatus-applied"
        );
        index.dom.chReject = index.dom.main.find(
          "#cid-" + json.courseid + "-uid-" + json.userid + "-chstatus-reject"
        );
        index.dom.chWithdraw = index.dom.main.find(
          "#cid-" + json.courseid + "-uid-" + json.userid + "-chstatus-withdraw"
        );
        index.dom.chApproved = index.dom.main.find(
          "#cid-" + json.courseid + "-uid-" + json.userid + "-crstatus-approved"
        );
      },
      changeStatus: function(data){
        var result = data.split("-");
        var courseid = result[1];
        var userid = result[3];
        var action = result[5];
        var datas = {
          courseid: courseid,
          userid: userid,
          action: action,
        };
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Are you sure you want to " + action + " this course?",
          showDenyButton: true,
          confirmButtonText: index.langs.yes,
          denyButtonText: index.langs.no,
          customClass: {
            actions: "my-actions",
            cancelButton: "order-1 right-gap",
            confirmButton: "order-2",
            denyButton: "order-3",
          },
        }).then((result) => {
          if(result.isConfirmed) {
            $.ajax({
              type: "POST",
              async: !0,
              data: datas,
              url: M.cfg.wwwroot + "/local/buykart/approve_mentorcourse.php?",
              success: function (json) {
                index.action.initDomVariable(json);
                var btnId = "cid-" + json.courseid + "-uid-" + json.userid;
                if (json.message == "apply-mentor") {
                  //Replace apply button to withdraw button mentor (changestatus)
                  index.dom.chApply.removeClass("btn-success");
                  index.dom.chApply.addClass("btn-secondary");
                  index.dom.chApply.html(index.langs.withdraw);
                  index.dom.chApply.attr("id", btnId + "-chstatus-withdraw");
                  //Replace reject button with appllied button (currentstatus)
                  index.dom.chRejected.removeClass("btn-danger");
                  index.dom.chRejected.addClass("btn-success");
                  index.dom.chRejected.html(index.langs.applied);
                  index.dom.chRejected.attr("id", btnId + "-crstatus-applied");
                  //Replace not applicable button to apllied button mentor (currentstatus)
                  index.dom.notApplicable.removeClass("btn-info");
                  index.dom.notApplicable.addClass("btn-success");
                  index.dom.notApplicable.html(index.langs.applied);
                  index.dom.notApplicable.attr(
                    "id",
                    btnId + "-crstatus-applied"
                  );
                } else if (json.message == "approve-mkadmin") {
                  if (json.prevstate == -1) {
                    //Approved button should be replaced by rejected button (currentstatus)
                    index.dom.chRejected.removeClass("btn-danger");
                    index.dom.chRejected.addClass("btn-success");
                    index.dom.chRejected.html(index.langs.approved);
                    index.dom.chRejected.attr(
                      "id",
                      btnId + "-crstatus-approved"
                    );
                    //Reject button should disappear and not applicable button should be shown (changestatus)
                    index.dom.chApprove.removeClass("btn-success");
                    index.dom.chApprove.addClass("btn-danger");
                    index.dom.chApprove.html(index.langs.reject);
                    index.dom.chApprove.attr("id", btnId + "-chstatus-reject");
                  } else if (json.prevstate == 0) {
                    //Applied button should be replaced by rejected button (currentstatus)
                    index.dom.chApplied.html(index.langs.approved);
                    index.dom.chApplied.attr(
                      "id",
                      btnId + "-crstatus-approved"
                    );
                    //Reject button should disappear and approve button should be available by default (changestatus)
                    index.dom.chApprove.removeClass("btn-success");
                    index.dom.chApprove.addClass("btn-danger");
                    index.dom.chApprove.html(index.langs.reject);
                    index.dom.chApprove.attr("id", btnId + "-chstatus-reject");
                    index.dom.chReject.remove();
                  }
                } else if (json.message == "withdraw-mentor") {
                  //Replace withdraw button to apply button mentor (changestatus)
                  index.dom.chWithdraw.removeClass("btn-secondary");
                  index.dom.chWithdraw.addClass("btn-success");
                  index.dom.chWithdraw.html(index.langs.apply);
                  index.dom.chWithdraw.attr("id", btnId + "-chstatus-apply");
                  //Replace applied button to Not applicable button mentor (currentstatus)
                  index.dom.chApplied.removeClass("btn-success");
                  index.dom.chApplied.addClass("btn-info");
                  index.dom.chApplied.html(index.langs.notApplicable);
                  index.dom.chApplied.attr(
                    "id",
                    btnId + "-crstatus-notapplicable"
                  );
                } else if (json.message == "reject-admin") {
                  if (json.prevstate == 2) {
                    //Approved button should be replaced by rejected button (currentstatus)
                    index.dom.chApproved.removeClass("btn-success");
                    index.dom.chApproved.addClass("btn-danger");
                    index.dom.chApproved.html(index.langs.rejected);
                    index.dom.chApproved.attr(
                      "id",
                      btnId + "-crstatus-rejected"
                    );
                    //Reject button should disappear and not applicable button should be shown (changestatus)
                    index.dom.chReject.removeClass("btn-danger");
                    index.dom.chReject.addClass("btn-success");
                    index.dom.chReject.html(index.langs.approve);
                    index.dom.chReject.attr("id", btnId + "-chstatus-approve");
                  } else if (json.prevstate == 0) {
                    //Applied button should be replaced by rejected button (currentstatus)
                    index.dom.chApplied.removeClass("btn-success");
                    index.dom.chApplied.addClass("btn-danger");
                    index.dom.chApplied.html(index.langs.rejected);
                    index.dom.chApplied.attr(
                      "id",
                      btnId + "-crstatus-rejected"
                    );
                    //Reject button should disappear and approve button should be available by default (changestatus)
                    index.dom.chReject.removeClass("btn-danger");
                    index.dom.chReject.addClass("btn-success");
                    index.dom.chReject.html(index.langs.approve);
                    index.dom.chReject.attr("id", btnId + "-chstatus-approve");
                    index.dom.chApprove.remove();
                  }
                }
              },
            });
          } else if (result.isDenied) {
            e.preventDefault();
          }
        });
      },
    },
    init: function () {
      index.dom.main = $("#table-mentor");
      index.dom.main.DataTable();
      index.dom.main.on("click", ".changestatus", function (e) {
        data = $(this).attr("id");
        index.action.changeStatus(data);
      });
    },
  };
  return {
    init: index.action.getString,
  };
});
